import React from "react";
import ApiName from "../../ApiName";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./Carousel.css"; // Keep if there are custom overrides

const ImageConverter = (images) => {
  var result = [];
  for (let i = 0; i < images.length; i++) {
    result.push({
      original: ApiName + "/" + images[i].path,
      originalAlt: "carousel-image",
      // Since thumbnails aren't used but expected by the package, we'll just pass original
      thumbnail: ApiName + "/" + images[i].path,
    });
  }
  return result;
};

const Carousel = ({ images }) => {
  return (
    <div className="w-full relative overflow-hidden">
      {images && images.length !== 0 ? (
        <ImageGallery
          additionalClass="homepage-carousel"
          items={ImageConverter(images)}
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={false}
          autoPlay={true}
          slideInterval={3000}
          slideDuration={500}
          showNav={true}
          showBullets={true}
        />
      ) : null}
    </div>
  );
};

export default Carousel;
